import { Component, OnChanges, OnInit } from '@angular/core';
import { UtilService } from 'src/app/util/UtilService';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class AlertPlayerRegisterPopupLayoutComponent
  implements OnInit, OnChanges
{
  _subscriptionScale;
  private resizeTimeOut;
  public contentWidth = 0;
  public contentHeight = 0;

  constructor(public _utilService: UtilService) {
    this.setContentHeight();
    this._subscriptionScale = _utilService.scaleChange.subscribe((value) => {
      // console.log('_subKKKKKKscriptionScale');
      this.resizeTimeOut = setTimeout(() => {
        this.setContentHeight();
        window.clearTimeout(this.resizeTimeOut);
        delete this.resizeTimeOut;
      }, 300);
    });
  }

  setContentHeight = () => {
    //console.log('setContentHeight setContentHeight setContentHeight setContentHeight');
    this.contentWidth = window.screen.availWidth;
    this.contentHeight =
      this._utilService.parentHeight != 0
        ? this._utilService.parentHeight
        : window.innerHeight;
  };

  ngOnInit() {}

  ngOnChanges(changeData) {}

  ngOnDestroy(): void {
    if (this.resizeTimeOut) {
      window.clearTimeout(this.resizeTimeOut);
    }
    if (this._subscriptionScale) {
      this._subscriptionScale.unsubscribe();
    }
    delete this.resizeTimeOut;
    delete this._subscriptionScale;
  }
}
